<!--
 * @Author: your name
 * @Date: 2021-08-10 08:10:09
 * @LastEditTime: 2022-03-01 13:16:47
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\components\footer.vue
-->
<template>
  <div class="footer_area">
    <div class="footer_one">
      <div class="footer_one_item">
        <img
          src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/footer/you.png"
          alt=""
        />
        <div class="footer_one_item_title">品质保障</div>
      </div>
      <div class="footer_one_item">
        <img
          src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/footer/kuai.png"
          alt=""
        />
        <div class="footer_one_item_title">急速发货</div>
      </div>
      <div class="footer_one_item">
        <img
          src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/footer/te.png"
          alt=""
        />
        <div class="footer_one_item_title">专属客服</div>
      </div>

      <div class="footer_one_item">
        <img
          src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/footer/cheng.png"
          alt=""
        />
        <div class="footer_one_item_title">诚信服务</div>
      </div>
    </div>
    <el-row
      class="bot"
      :gutter="24"
      justify="center"
      style="
        width: 1200px;
        height: 205px;
        margin: 0 auto;
        border-top: 1px solid #e0e0e0;
      "
    >
      <el-col :span="3">
        <div class="grid-content bg-purple">
          <div class="list_title">购物指南</div>
          <ul>
            <li @click="toArticleDetail(283)">
              <span class="strokeDiv">购物流程</span>
            </li>
            <li @click="toArticleDetail(285)">
              <span class="strokeDiv">发票须知</span>
            </li>
            <li @click="toArticleDetail(284)">
              <span class="strokeDiv">支付方式</span>
            </li>
            <li @click="toArticleDetail(288)">
              <span class="strokeDiv">配送方式</span>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="3" :offset="2">
        <div class="grid-content bg-purple">
          <div class="list_title">用户保障</div>
          <ul>
            <li @click="toArticleDetail(300)">
              <span class="strokeDiv">售后服务</span>
            </li>
            <li @click="toArticleDetail(286)">
              <span class="strokeDiv">用户服务协议</span>
            </li>
            <li @click="toArticleDetail(287)">
              <span class="strokeDiv">隐私政策</span>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="3" :offset="2">
        <div class="grid-content bg-purple">
          <div class="list_title">关于我们</div>
          <ul>
            <li @click="toArticleDetail(292)">
              <span class="strokeDiv">公司介绍</span>
            </li>
            <li @click="toArticleDetail(294)">
              <span class="strokeDiv">加入我们</span>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="4" :offset="2">
        <div class="grid-content bg-purple">
          <div class="list_title">联系我们</div>
          <ul>
            <li><span class="strokeDiv">手机：13564307156</span></li>
            <li><span class="strokeDiv">邮箱：sales@bioselec.cn</span></li>
            <li><span class="strokeDiv"></span></li>
          </ul>
        </div>
      </el-col>
      <el-col :span="3" :offset="2">
        <div class="wx">
          <img
            src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/index/wxxcx.png"
            alt=""
          />
          <p>生科供应链官方小程序</p>
        </div>
      </el-col>
    </el-row>
    <div style="background-color: #333;width: 100%;height: 20px;color: #fff;font-size: 12px;text-align: center;align-items: center;margin-top: 10px;">
      <div>
        <a target="_blank" style="background-color: #333;width: 100%;height: 20px;color: #fff;font-size: 12px;text-align: center;align-items: center;" href="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/prod/certs/%E4%BA%8C%E7%B1%BB%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E7%BB%8F%E8%90%A5%E5%A4%87%E6%A1%88%E5%87%AD%E8%AF%81.pdf">二类医疗器械经营备案凭证：苏苏药监械经营备20221062号</a>
        | 
        <a target="_blank" style="background-color: #333;width: 100%;height: 20px;color: #fff;font-size: 12px;text-align: center;align-items: center;" href="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/prod/certs/%E7%AC%AC%E4%B8%89%E7%B1%BB%E5%8C%BB%E7%96%97%E5%99%A8%E6%A2%B0%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81.pdf">第三类医疗器械经营许可证：苏苏药监械经营许20231011号</a>
        | 
        <a target="_blank" style="background-color: #333;width: 100%;height: 20px;color: #fff;font-size: 12px;text-align: center;align-items: center;" href="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/prod/certs/%E4%BA%92%E8%81%94%E7%BD%91%E8%8D%AF%E5%93%81%E4%BF%A1%E6%81%AF%E6%9C%8D%E5%8A%A1%E8%B5%84%E6%A0%BC%E8%AF%81.pdf">互联网药品信息服务资格证：(苏)-经营性-2023-0002</a>
        </div>
      <div>  
        <a target="_blank" style="background-color: #333;width: 100%;height: 20px;color: #fff;font-size: 12px;text-align: center;align-items: center;" href="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/prod/certs/%E7%94%9F%E7%A7%91%E4%BA%91%E9%80%89%E8%90%A5%E4%B8%9A%E6%89%A7%E7%85%A7.pdf">生科云选营业执照：91320594MA7DYJWG32</a>
        | 
        <a target="_blank" style="background-color: #333;width: 100%;height: 20px;color: #fff;font-size: 12px;text-align: center;align-items: center;" href="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/prod/certs/%E5%A2%9E%E5%80%BC%E7%94%B5%E4%BF%A1%E4%B8%9A%E5%8A%A1%E7%BB%8F%E8%90%A5%E8%AE%B8%E5%8F%AF%E8%AF%81.pdf">增值电信业务经营许可证：苏B2-20220927</a>
      </div>
    </div>
    <div class="copyright">
      <div>版权所有 &copy; 苏州生科云选生物科技有限公司&emsp;</div>
      <div style="width: 275px">
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32059002003905"
        >
          <img
            src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/index/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png"
            style="float: left"
          />
          <p
            style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
              color: #fff;
            "
          >
            苏公网安备 32059002003905号
          </p>
        </a>
      </div>
      <a href="https://beian.miit.gov.cn">苏ICP备2022004222号</a>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"], //注入强制刷新依赖 
  data() {
    return {};
  },
  computed: {
    loginName: function () {
      return store.getters.getUserName;
    },
  },
  methods: {
    toArticleDetail(articleId) {
      this.$router.push({
        path: "../article/articleList",
        query: {
          id: articleId
        },
      });
    },
  },
};
</script>
<style scoped>
.footer_area {
  width: 100%;
  min-width: 1200px;
  overflow-y: hidden;
  background-color: #fff;
}
/* 正品保障、货期保证部分 */
.footer_one {
  width: 1200px;
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 53px auto 26px;
  text-align: left;
}
.footer_one_item {
  display: flex;
  align-items: center;
}
.footer_one_item img {
  width: 35px;
  height: 35px;
  margin-right: 10px;
}
.footer_one_item_title {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
/* 底部的购物指南、售后服务等部分 */
.list_title {
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
  text-align: left;
  margin-top: 40px;
  font-size: 14px;
}
.bg-purple ul li {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
  text-align: left;
}
.bg-purple img {
  width: 94px;
  height: 94px;
}
.bg-purple p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}
/* 版权部分 */
.copyright {
  width: 100%;
  height: 47px;
  background-color: #333;
  line-height: 47px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.copyright a {
  color: #fff;
}
.QR_code_title {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 22px;
}
.bot {
  width: 1200px;
  display: flex;
  justify-content:space-between;
}
.wx {
    /* width: 130px; */
  margin-top: 45px;
}
.wx img{
    width: 94px;
    height: 94px;
    margin: 0 auto;
}
.wx p {
    width: 130px;
  line-height: 40px;
  text-align: center;
}

</style>


// WEBPACK FOOTER //
// src/components/pageComponents/footer.vue